module.exports = __webpack_public_path__ + "img/LogoDashboard-15.8df786cd.svg";